export default __webpack_public_path__ + "static/media/Walker's Straps of the Golden Horde.09bdd4aa.jpg";